import React, { useState } from 'react';
import SubHeader from "components/menu/SubHeader";
import { UserApprovalsSidebar } from "./UserApprovalsSidebar";
import './UserApprovals.css';
import { ISelectOption } from '../forms/util';

interface UserApprovalsPageProps {
    selectedPage: ISelectOption,
    children?: React.ReactNode
}

const UserApprovalsPage = (props: UserApprovalsPageProps) => {
    const [currentSelection] = useState(props.selectedPage);

    return (
        <>
            <div className="user-approvals">
                <div className="user-approvals-header-bg"></div>
                <div className="narrow-container">
                    <SubHeader />
                    <div className="user-approvals-page">
                        <div className="row">
                            <div className="ua-wide col-3">
                                <UserApprovalsSidebar selectedPage={currentSelection} />
                            </div>
                            <div className="col">
                                <React.Fragment>{props.children}</React.Fragment>
                            </div>
                        </div>

                        <div className="user-approvals-footer"></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserApprovalsPage;
